<tabset>
  <tab *ngFor="let tab of component.data.tabs">
    <ng-template tabHeading>
      {{ tab.title }}
    </ng-template>
    <div class="ql-editor" [innerHtml]="tab.content"></div>
  </tab>
</tabset>
